import { render, staticRenderFns } from "./NavLink.vue?vue&type=template&id=31cb8b9d&scoped=true&"
import script from "./NavLink.vue?vue&type=script&lang=js&"
export * from "./NavLink.vue?vue&type=script&lang=js&"
import style0 from "./NavLink.scss?vue&type=style&index=0&id=31cb8b9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb8b9d",
  null
  
)

export default component.exports